var $19f181cdd9af3e41$exports = {};
$19f181cdd9af3e41$exports = {
    "replaceMessage": `Ejtse le a f\xe1jlt a cser\xe9hez`
};


export {$19f181cdd9af3e41$exports as default};
//# sourceMappingURL=hu-HU.mjs.map
